module.exports = __webpack_public_path__ + "static/media/lg15.0bd73b4d.png";